
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68b553a4424dd48e8c03f9c3";
              window.beaePageSetting.pageTitle = "Footer_Beae_2025"; 
              window.beaePageSetting.pageType = "footer";

          let js_7UF5HH0H = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-xwetzcbvsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xwetzcbv',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xwetzcbv');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xwetzcbv: ', ex)
      };
    

      try {
        let argid = 'beae-oassgf0gblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oassgf0g',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oassgf0g');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oassgf0g: ', ex)
      };
    

      try {
        let argid = 'beae-2kph6l9mblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2kph6l9m',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2kph6l9m');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2kph6l9m: ', ex)
      };
    

      try {
        let argid = 'beae-ouuf39g6block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ouuf39g6',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ouuf39g6');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ouuf39g6: ', ex)
      };
    

      try {
        let argid = 'beae-56cuzkqbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-56cuzkqb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-56cuzkqb');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-56cuzkqb: ', ex)
      };
    

      try {
        let argid = 'beae-2nlxm8acsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2nlxm8ac',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2nlxm8ac');
        args.el = args.els[0];
        ((g) => { window.BeaeSlider&&!g.noRunJs&&window.BeaeSlider(g) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2nlxm8ac: ', ex)
      };
    

      try {
        let argid = 'beae-n7uk4jxtblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n7uk4jxt',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n7uk4jxt');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n7uk4jxt: ', ex)
      };
    

      try {
        let argid = 'beae-4xltkkx8block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4xltkkx8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4xltkkx8');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4xltkkx8: ', ex)
      };
    

      try {
        let argid = 'beae-tozul67zsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tozul67z',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tozul67z');
        args.el = args.els[0];
        ((g) => { window.BeaeSlider&&!g.noRunJs&&window.BeaeSlider(g) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tozul67z: ', ex)
      };
    

      try {
        let argid = 'beae-viiz46xxblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-viiz46xx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-viiz46xx');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-viiz46xx: ', ex)
      };
    

      try {
        let argid = 'beae-viiz46xxblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-viiz46xx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-viiz46xx');
        args.el = args.els[1];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-viiz46xx: ', ex)
      };
    

      try {
        let argid = 'beae-viiz46xxblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-viiz46xx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-viiz46xx');
        args.el = args.els[2];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-viiz46xx: ', ex)
      };
    

      try {
        let argid = 'beae-zygkciwflinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zygkciwf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zygkciwf');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zygkciwf: ', ex)
      };
    

      try {
        let argid = 'beae-4ddhumsmblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4ddhumsm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4ddhumsm');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4ddhumsm: ', ex)
      };
    

      try {
        let argid = 'beae-9flkhhl0linkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9flkhhl0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9flkhhl0');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9flkhhl0: ', ex)
      };
    

      try {
        let argid = 'beae-r12ul7beblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-r12ul7be',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-r12ul7be');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-r12ul7be: ', ex)
      };
    

      try {
        let argid = 'beae-n2t0v71clinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n2t0v71c',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n2t0v71c');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n2t0v71c: ', ex)
      };
    

      try {
        let argid = 'beae-2xmkhop2block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2xmkhop2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2xmkhop2');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2xmkhop2: ', ex)
      };
    

      try {
        let argid = 'beae-bkhb095nblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bkhb095n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bkhb095n');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bkhb095n: ', ex)
      };
    

      try {
        let argid = 'beae-5g63kdknblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5g63kdkn',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5g63kdkn');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5g63kdkn: ', ex)
      };
    

      try {
        let argid = 'beae-1jf8oyigblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1jf8oyig',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1jf8oyig');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1jf8oyig: ', ex)
      };
    

      try {
        let argid = 'beae-jjg2vanoblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jjg2vano',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jjg2vano');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jjg2vano: ', ex)
      };
    }; if (window.BEAEBASE) {js_7UF5HH0H()} else {window.BEAEPAGEJS.push(js_7UF5HH0H)} })(); 